(function eventTracking() {
  /**
   * Determines the page template type based on the current URL path.
   * @returns {string|null} The page template type ('page', 'product', 'collection'), or null if not matched.
   */
  function getPageTemplate() {
    const path = window.location.pathname;

    if (path.includes('/pages/')) {
      return 'page';
    } else if (path.includes('/products/')) {
      return 'product';
    } else if (path.includes('/collections/')) {
      return 'collection';
    }

    return null;
  }

  /**
   * Retrieves the shipping country from the Shopify object.
   * @returns {string|null} The shipping country code, or null if not available.
   */
  function getShippingCountry() {
    if (window.Shopify && window.Shopify.country) {
      return window.Shopify.country.toLowerCase();
    }

    return null;
  }

  /**
   * Retrieves the clean page path by removing trailing slashes and locale/country subfolders.
   * @returns {string} The clean page path without locale/country prefix.
   */
  function getPagePathClean() {
    let path = window.location.pathname;

    path = path.replace(/^\/[a-z]{2}(-[a-z]{2,4})?\//, '/');
    path = path.replace(/\/$/, '');

    return path;
  }

  const pageTemplate = getPageTemplate();
  const pagePathClean = getPagePathClean();
  const shippingCountry = getShippingCountry();

  (function eventTrackingBreadcrumbs() {
    const element = document.querySelector('section.section-breadcrumbs');

    if (!element) return;

    element.addEventListener('click', (e) => {
      const link = e.target instanceof Element && e.target.closest('.breadcrumbs-item a');
      const deadLink = e.target instanceof Element && e.target.closest('.breadcrumbs-item:not(:has(a))');

      if (link) {
        window.gtag('event', 'module_interaction', {
          interaction_type: 'click',
          module_type: 'breadcrumb',
          element_type: 'breadcrumb_item',
          element_text: link.textContent?.trim().toLowerCase() || '',
          element_index:
            Array.from(element.querySelectorAll('.breadcrumbs-item')).indexOf(
              link.closest('.breadcrumbs-item') || link,
            ) + 1,
          element_index_count: element.querySelectorAll('.breadcrumbs-item').length,
          page_template: pageTemplate,
          page_path_clean: pagePathClean,
          ship_to_country: shippingCountry,
        });
      }

      if (deadLink) {
        window.gtag('event', 'module_interaction', {
          interaction_type: 'dead_click',
          module_type: 'breadcrumb',
          element_type: 'breadcrumb_item',
          element_text: deadLink.textContent?.trim().toLowerCase() || '',
          element_index:
            Array.from(element.querySelectorAll('.breadcrumbs-item')).indexOf(
              deadLink.closest('.breadcrumbs-item') || deadLink,
            ) + 1,
          element_index_count: element.querySelectorAll('.breadcrumbs-item').length,
          page_template: pageTemplate,
          page_path_clean: pagePathClean,
          ship_to_country: shippingCountry,
        });
      }
    });

    /** @type {number|null} */
    let timer = null;

    new IntersectionObserver((entries, observer) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        timer = Date.now();

        window.gtag('event', 'module_inview', {
          page_template: pageTemplate,
          module_type: 'breadcrumb',
          page_path_clean: pagePathClean,
          ship_to_country: shippingCountry,
        });
      } else if (timer !== null) {
        const milliseconds = Date.now() - timer;

        timer = null;

        window.gtag('event', 'module_outview', {
          page_template: pageTemplate,
          module_type: 'breadcrumb',
          seconds_in_view: milliseconds / 1000,
          page_path_clean: pagePathClean,
          ship_to_country: shippingCountry,
        });

        observer.unobserve(element);
      }
    }).observe(element);
  })();
})();
